export default {
  loading: false,
  dashboard: [],
  order:{},
  order_list:{},
  totalCount: 0,
  page:0,
};
